// extracted by css-extract-rspack-plugin
export default {"IconMargin":"FZx18"};